export default __webpack_public_path__ + "static/media/versedBrighteningSerum.dd48a3f8.jpg";